export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00711.df134ab0.png";